import React from "react";
import { Box, Typography } from "@mui/material";
import Headerimg from "../../assets/images/headerBackground.webp";
import overlayImage from "../../assets/images/overlayImg.webp";
import { motion } from "framer-motion";

const MotionBox = motion.create(Box);

const HeaderSection = ({ title }) => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${Headerimg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "376px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        textAlign: "center",
        mb: { xs: "35px", md: "88px" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#061332c9",
          zIndex: 1,
        }}
      />
      <MotionBox
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        sx={{
          padding: "48px 24px",
          borderRadius: "8px",
          width: { xs: "100%", md: "60%" },
          zIndex: 222,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            position: "relative",
            zIndex: 2,
            fontWeight: "bold",
          }}
        >
          {title}
        </Typography>{" "}
      </MotionBox>

      <Box
        component="img"
        src={overlayImage}
        alt="Overlay Image"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 3,
        }}
      />
    </Box>
  );
};

export default HeaderSection;
